'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PolicyQuoteIcon = function (_React$Component) {
    _inherits(PolicyQuoteIcon, _React$Component);

    function PolicyQuoteIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PolicyQuoteIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PolicyQuoteIcon.__proto__ || Object.getPrototypeOf(PolicyQuoteIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (width, height, primary) {
            return _react2.default.createElement(
                'svg',
                { id: 'Policy_Quote', xmlns: 'http://www.w3.org/2000/svg', width: '100', height: '99.99', viewBox: '0 0 100 99.99' },
                _react2.default.createElement('path', { id: 'Path_12506', 'data-name': 'Path 12506', d: 'M59.71,28.8H14.4a1.46,1.46,0,1,1,0-2.92H59.71a1.46,1.46,0,1,1,0,2.92Z', fill: _colors.Colors.Primary }),
                _react2.default.createElement('path', { id: 'Path_12507', 'data-name': 'Path 12507', d: 'M40.29,48.22H14.4a1.46,1.46,0,1,1,0-2.92H40.29a1.46,1.46,0,1,1,0,2.92Z', fill: _colors.Colors.Primary }),
                _react2.default.createElement('path', { id: 'Path_12508', 'data-name': 'Path 12508', d: 'M30.58,67.63H14.4a1.46,1.46,0,1,1,0-2.92H30.58a1.46,1.46,0,1,1,0,2.92Z', fill: _colors.Colors.Primary }),
                _react2.default.createElement('path', { id: 'Path_12509', 'data-name': 'Path 12509', d: 'M30.58,87.05H7.93A7.942,7.942,0,0,1,0,79.12V7.93A7.942,7.942,0,0,1,7.93,0H53.79a7.833,7.833,0,0,1,5.6,2.32L71.78,14.71a7.867,7.867,0,0,1,2.32,5.6v13.5a1.46,1.46,0,0,1-2.92,0V20.31a4.945,4.945,0,0,0-1.47-3.54L57.33,4.38a4.985,4.985,0,0,0-3.55-1.47H7.93A5.03,5.03,0,0,0,2.91,7.93V79.12a5.023,5.023,0,0,0,5.02,5.02H30.58a1.455,1.455,0,1,1,0,2.91Z', fill: _colors.Colors.Primary }),
                _react2.default.createElement('path', { id: 'Path_12510', 'data-name': 'Path 12510', d: 'M74.97,83.19a8.431,8.431,0,0,1-6.67-3.33,1.456,1.456,0,1,1,2.32-1.76,5.557,5.557,0,0,0,4.63,2.18c2.79,0,5.09-1.56,5.09-3.41s-2.3-3.41-5.02-3.41c-4.38,0-7.94-2.84-7.94-6.32s3.56-6.32,7.94-6.32a8.408,8.408,0,0,1,7,3.33A1.456,1.456,0,0,1,80,65.91a5.557,5.557,0,0,0-4.63-2.18c-2.79,0-5.09,1.56-5.09,3.41s2.3,3.41,5.03,3.41c4.37,0,7.93,2.83,7.93,6.32s-3.56,6.32-7.95,6.32Z', fill: _colors.Colors.Secondary }),
                _react2.default.createElement('path', { id: 'Path_12511', 'data-name': 'Path 12511', d: 'M75.31,86.42a1.462,1.462,0,0,1-1.46-1.46V81.72a1.46,1.46,0,0,1,2.92,0v3.24A1.462,1.462,0,0,1,75.31,86.42Z', fill: _colors.Colors.Secondary }),
                _react2.default.createElement('path', { id: 'Path_12512', 'data-name': 'Path 12512', d: 'M75.31,63.72a1.462,1.462,0,0,1-1.46-1.46V59.02a1.46,1.46,0,0,1,2.92,0v3.24A1.462,1.462,0,0,1,75.31,63.72Z', fill: _colors.Colors.Secondary }),
                _react2.default.createElement('path', { id: 'Path_12513', 'data-name': 'Path 12513', d: 'M75.53,99.99a1.17,1.17,0,0,1-.32-.04A30.7,30.7,0,0,1,51.06,69.76V56.2a7.187,7.187,0,0,1,4.4-6.64,49.574,49.574,0,0,1,40.16.01A7.2,7.2,0,0,1,100,56.2l-.01,13.58A30.694,30.694,0,0,1,75.84,99.96,1.627,1.627,0,0,1,75.53,99.99Zm0-51.76a46.572,46.572,0,0,0-18.91,4,4.3,4.3,0,0,0-2.64,3.97V69.78A27.79,27.79,0,0,0,75.53,97.05,27.79,27.79,0,0,0,97.08,69.78h0l.01-13.58a4.3,4.3,0,0,0-2.62-3.96A46.627,46.627,0,0,0,75.53,48.23Z', fill: _colors.Colors.Secondary })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PolicyQuoteIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                { size: 100 },
                this.getIcon(null, null, this.props.primary)
            );
        }
    }]);

    return PolicyQuoteIcon;
}(_react2.default.Component);

exports.default = PolicyQuoteIcon;